
import React from 'react';
import { motion } from 'framer-motion';
import { Language } from '../App';

const FinalCTA: React.FC<{ lang: Language }> = ({ lang }) => {
  const t = {
    pt: {
      title: "LISTAGEM É O COMEÇO.",
      highlight: "ADOÇÃO É O JOGO.",
      desc: "95% dos projetos falham por falta de utilidade real e acesso. Nós resolvemos a barreira técnica para os próximos 1 milhão de usuários.",
      btn: "Agendar Conversa"
    },
    en: {
      title: "LISTING IS THE START.",
      highlight: "ADOPTION IS THE GAME.",
      desc: "95% of projects fail due to lack of real utility and access. We solve the technical barrier for the next 1 million users.",
      btn: "Schedule a Call"
    }
  }[lang];

  return (
    <section className="py-24 md:py-48 relative overflow-hidden bg-black">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-red-600/5 blur-[100px] rounded-full z-0"></div>
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-8xl font-black text-white mb-6 md:mb-10 tracking-tighter leading-[0.9] uppercase italic">
            {t.title}<br/>
            <span className="gradient-text">{t.highlight}</span>
          </h2>
          <p className="text-base md:text-2xl text-zinc-400 mb-10 md:mb-14 max-w-3xl mx-auto leading-relaxed font-medium px-4">
            {t.desc}
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 px-4">
            <a 
              href="https://t.me/Ceo_RHT"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto gradient-bg hover:brightness-110 text-white px-10 py-5 rounded-2xl text-xs md:text-sm font-black uppercase tracking-[0.2em] transition-all transform hover:scale-105 btn-glow text-center"
            >
              {t.btn}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
